module.exports = __webpack_public_path__ + "static/media/green.8a9e73ab.png";